/**
 * PlayersPanel — left rail list of PlayerCards.
 *
 * Originally derived from the (removed) board-game-playground for visual parity. UI is NOT shared (CLAUDE.md).
 * Adapted for multiplayer: highlights the current user's seat.
 */

import type { PlayerState } from "@cloudnest/cascadia-engine";
import { PlayerCard } from "./PlayerCard";

export interface PlayersPanelProps {
  readonly players: readonly PlayerState[];
  readonly activeSeat: number;
  readonly myPlayerIndex: number | null;
}

export function PlayersPanel({
  players,
  activeSeat,
  myPlayerIndex,
}: PlayersPanelProps) {
  return (
    <aside
      data-testid="cascadia-players-panel"
      aria-label="Players"
      style={{
        display: "flex",
        flexDirection: "column",
        gap: 8,
      }}
    >
      {players.map((player, i) => (
        <PlayerCard
          key={player.playerId}
          player={player}
          isActive={i === activeSeat}
          seatIndex={i}
          isMyPlayer={i === myPlayerIndex}
        />
      ))}
    </aside>
  );
}
